import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from 'reactstrap';

class AbsPosButton extends Component {

  static propTypes = {
    // Positioning Properties
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

    // Bootstrap Button Properties
    color: PropTypes.string,
    onClick: PropTypes.func,

    // Other
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.string,
  }

  static defaultProps = {
    top:    '15%',
    bottom: false,
    left:   false,
    right:  '25%',
    color:  'secondary',
    onClick: () => {},
    className: '',
    style: {},
    children: '',
  }

  render() {
    const {
      top,
      bottom,
      left,
      right,
      color,
      onClick,
      className,
      style,
      children
    } = this.props;

    return (
      <div
        className={`AbsPosButton ${className}`}
        style={{
          zIndex: 100,
          position: 'absolute',
          top:    (top)    ? top    : '',
          bottom: (bottom) ? bottom : '',
          left:   (left)   ? left   : '',
          right:  (right)  ? right  : ''
        }}
      >
        <Button
          color={color}
          onClick={onClick}
          style={{
            padding: '1rem 2rem',
            ...style
          }}
        >
          {children}
        </Button>
      </div>
    );
  }
}

export default AbsPosButton;



// WEBPACK FOOTER //
// ./src/pages/Demo/components/AbsPosButton/AbsPosButton.js